import { Box, Stack, Typography } from "@mui/material";
import logo_horizontal from "../images/ursi2026_ursi_ull_horizontal.svg";
import logo_vertical from "../images/ursi2026_ursi_ull_vertical.svg";
import React from "react";
import { globalMaxWidth } from "../GlobalConfigs";
import SponsorCarousel from "./PatrocinadoresCarousel";

export function TopBanner() {
    return (
        <Stack
            direction='column'
            justifyContent='space-around'
            alignItems='center'
            sx={{
                width: 1,
                maxWidth: globalMaxWidth,
            }}>
            <Stack
                direction={{ md: 'row', sm: 'column' }}
                spacing={1}
                justifyContent='space-around'
                alignItems={{ md: 'end', sm: 'center', xs: 'center' }}
                // padding={1}
                sx={{
                    width: 1,
                    maxWidth: globalMaxWidth,
                }}>
                <Stack sx={{
                    width: {
                        md: '95%',
                        sm: '35%',
                        xs: '35%'
                    },
                    aspectRatio: {
                        md: '1 / 0.2',
                        sm: '0.6',
                        xs: '0.6'
                    },
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    backgroundImage: {
                        md: `url(${logo_horizontal})`,
                        sm: `url(${logo_vertical})`,
                        xs: `url(${logo_vertical})`
                    }
                }}
                />
            </Stack>

            <SponsorCarousel />
        </Stack>
    )
}